/**
 * TiendaGate — envuelve la ruta /complementos.
 * Si el super admin tiene tienda_complementos_visible=false, redirige a /suscripcion.
 * super_admin bypass total.
 */
import { Navigate } from 'react-router-dom';
import { useAuth } from '@/contexto/AuthContexto';

export default function TiendaGate({ children }) {
  const { usuario, tiendaVisible } = useAuth();
  if (usuario?.rol === 'super_admin') return children;
  // Aún cargando el flag → esperar (evita race condition en hard refresh)
  if (tiendaVisible === null) return null;
  if (!tiendaVisible) return <Navigate to="/suscripcion" replace />;
  return children;
}
